module.exports = __webpack_public_path__ + "images/stickers/thumbsup@2x.397f36a2a71c3018a6f3.png";